import { commonEditArticleFields } from "../../../articles/components/articleForm";

export default {
  ...commonEditArticleFields({ allowDecimals: true }),
  "details.material": {
    defaultValue: ""
  },
  "details.length": {
    defaultValue: null,
    error: (length) => !isNaN(length) && parseFloat(length) <= 0,
    convert: value => parseFloat(value) || null, // input -> value
    convertBack: value => value || "", // value -> input
    required: false,
  },
  "details.width": {
    defaultValue: null,
    error: width => width <= 0,
    convert: value => parseFloat(value) || null, // input -> value
    convertBack: value => value || "" // value -> input
  },
  "details.thickness": {
    defaultValue: null,
    error: thickness => !isNaN(thickness) && thickness <= 0,
    convert: value => parseFloat(value) || null, // input -> value
    convertBack: value => value || "" // value -> input
  },
  "details.weight": {
    defaultValue: null,
    error: specificWeight =>
      !isNaN(specificWeight) && parseFloat(specificWeight) <= 0,
    convert: value => parseFloat(value) || null, // input -> value
    convertBack: value => value || "" // value -> input
  }
};
